module.exports = __webpack_public_path__ + "9b8d3c095a04ec8529ea1c8f46ef2c13.svg";